<template>
  <div class="box-item box-item--dark box-info">
      <h1>{{text}}</h1>
  </div>
</template>


<script>
  export default {
    name: 'ItineraryNotPublished',
    props: ['title', 'itinerary_published_at_text'],
    computed: {
      text() {
        if (this.itinerary_published_at_text && this.itinerary_published_at_text.length > 0) {
          return `YOUR ITINERARY WILL BE LIVE ON ${this.itinerary_published_at_text.toUpperCase()}`
        } else {
          return 'YOUR ITINERARY IS NOT YET LIVE'
        }
      }
    }
  }
</script>
